"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _styles2 = require("@mui/material/styles");
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _reactMaterialUiFormValidator = require("react-material-ui-form-validator");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    input: {
      // display: 'flex !important',
      // padding: 0,
    },
    valueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      alignItems: 'center',
      '& > p': {
        font: 'inherit'
      }
    },
    chip: {
      margin: "".concat(theme.spacing(0.5), "px ").concat(theme.spacing(0.25), "px"),
      '&focus': {
        backgroundColor: (0, _styles2.emphasize)(theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
      }
    },
    chipLabel: {
      maxWidth: '100px',
      overflow: 'hidden'
    },
    noOptionsMessage: {
      padding: "".concat(theme.spacing(1), "px ").concat(theme.spacing(2), "px")
    },
    placeholder: {
      display: 'none'
    },
    paper: {
      position: 'absolute',
      zIndex: 6,
      marginTop: "".concat(theme.spacing(2), "px"),
      left: 0,
      right: 0
    },
    textField: {
      // marginTop: '.5rem',
      // marginBottom: '.25rem',
    },
    option: {
      '& > div': {
        backgroundColor: 'transparent',
        color: 'black'
      },
      '& > div:active': {
        backgroundColor: 'transparent'
      }
    },
    inputRoot: {
      // paddingTop: '.375rem',
      // paddingBottom: '.4375rem',
    },
    inputLabelRoot: {
      width: 'calc(100% - 2.25rem)',
      fontSize: '1rem'
    }
  };
};
var CustomSelect = /*#__PURE__*/function (_Component) {
  function CustomSelect(props) {
    (0, _classCallCheck2["default"])(this, CustomSelect);
    return _callSuper(this, CustomSelect, [props]);
  }
  (0, _inherits2["default"])(CustomSelect, _Component);
  return (0, _createClass2["default"])(CustomSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        _this$props$label = _this$props.label,
        label = _this$props$label === void 0 ? '' : _this$props$label,
        _this$props$isMulti = _this$props.isMulti,
        isMulti = _this$props$isMulti === void 0 ? false : _this$props$isMulti,
        _this$props$isClearab = _this$props.isClearable,
        isClearable = _this$props$isClearab === void 0 ? false : _this$props$isClearab,
        _this$props$required = _this$props.required,
        required = _this$props$required === void 0 ? false : _this$props$required,
        onChange = _this$props.onChange,
        name = _this$props.name,
        _this$props$disabled = _this$props.disabled,
        disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
        _this$props$parents = _this$props.parents,
        parents = _this$props$parents === void 0 ? [] : _this$props$parents,
        question = _this$props.question,
        questionDescription = _this$props.questionDescription,
        placeholder = _this$props.placeholder;
      var _this$props2 = this.props,
        value = _this$props2.value,
        options = _this$props2.options;
      var validators = [];
      var errorMessages = [];
      validators.push('required');
      errorMessages.push('This field is required');
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        variant: "standard",
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_material.Autocomplete, {
        classes: classes,
        name: name
        //{...required}
        //validators={validators}
        ,
        label: label,
        fullWidth: true,
        options: options ? options : [],
        value: isMulti && !value ? [] : !value ? undefined : value,
        onChange: onChange(name, [].concat(parents, [question])),
        multiple: isMulti,
        renderInput: function renderInput(params) {
          return required ? /*#__PURE__*/_react["default"].createElement(_reactMaterialUiFormValidator.TextValidator, (0, _extends2["default"])({}, params, {
            variant: "standard",
            validators: value.length === 0 ? validators : [],
            errorMessages: errorMessages,
            questionDescription: questionDescription
          })) : /*#__PURE__*/_react["default"].createElement(_material.TextField, (0, _extends2["default"])({}, params, {
            label: label
          }));
        },
        renderOption: function renderOption(props, option) {
          return /*#__PURE__*/_react["default"].createElement("li", (0, _extends2["default"])({}, props, {
            key: option.value + '-' + option.label
          }), option.label);
        },
        disabled: disabled,
        isOptionEqualToValue: function isOptionEqualToValue(option, value) {
          return !value || !value.value || value != '' && option.value == value.value;
        },
        getOptionLabel: function getOptionLabel(option) {
          return option.label ? option.label.toString() : '';
        }
      })));
    }
  }]);
}(_react.Component);
CustomSelect.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  theme: _propTypes["default"].object.isRequired,
  disabled: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
  })),
  isMulti: _propTypes["default"].bool,
  onChange: _propTypes["default"].func.isRequired,
  name: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  withTheme: true
})(CustomSelect);